import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { JWT_LS } from '../constants'
import { authApi } from '../api/authApi'
import { usersApi } from '../api/userApi'
import { IToken } from '../model/interfaces'

export interface IAuthState {
  token: string
  isLoggedIn: boolean
}

const initialState: IAuthState = {
  token: localStorage.getItem(JWT_LS) || '',
  isLoggedIn: false
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken(state, action: PayloadAction<string>) {
      state.token = action.payload
      localStorage.setItem(JWT_LS, action.payload)
    },
    setIsLoggedIn(state, action: PayloadAction<boolean>) {
      state.isLoggedIn = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      authApi.endpoints?.signIn.matchFulfilled,
      (state: IAuthState, { payload }: PayloadAction<IToken>) => {
        state.token = payload.token
        state.isLoggedIn = true
        localStorage.setItem(JWT_LS, payload.token)
      }
    )
    builder.addMatcher(
      usersApi.endpoints?.getUser.matchFulfilled,
      (state: IAuthState, { payload }: PayloadAction<IToken>) => {
        state.isLoggedIn = true
      }
    )
  }
})

export const authActions = authSlice.actions
export const authReducer = authSlice.reducer
